import { takeLatest } from 'redux-saga/effects'
import { FETCH_MESSAGES_DATA_SAGA } from 'src/store/types/messagesData'
import fetchMessagesData from './fetchMessagesData'

export function* messagesDataSaga() {
  yield takeLatest(FETCH_MESSAGES_DATA_SAGA, fetchMessagesData)
}
